import { render, staticRenderFns } from "./ErrorFallback.vue?vue&type=template&id=6f5104a3&scoped=true&"
import script from "./ErrorFallback.vue?vue&type=script&lang=js&"
export * from "./ErrorFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5104a3",
  null
  
)

export default component.exports